import React from "react";
import { Check, Printer, BarChart3 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";
import { IMAGES } from "../../data/mock";
import SectionHeading from "../SectionHeading";
import Reveal from "../Reveal";

const FeatureCard = ({ tag, title, desc, points, image, icon: Icon, reverse }) => (
  <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
    <div className={reverse ? "lg:order-2" : ""}>
      <div className="relative rounded-2xl overflow-hidden border border-slate-200 shadow-xl">
        <img src={image} alt={title} className="w-full h-[320px] object-cover" />
        <div className="absolute top-4 left-4 flex items-center gap-2 rounded-lg bg-white/90 backdrop-blur px-3 py-2">
          <Icon className="w-5 h-5 text-amber-500" />
          <span className="text-sm font-semibold text-navy-900">{tag}</span>
        </div>
      </div>
    </div>
    <div className={reverse ? "lg:order-1" : ""}>
      <span className="text-xs font-semibold uppercase tracking-wider text-amber-500">{tag}</span>
      <h3 className="mt-2 font-display font-bold text-2xl lg:text-3xl text-navy-900 leading-tight">
        {title}
      </h3>
      <p className="mt-4 text-slate-600 leading-relaxed">{desc}</p>
      <ul className="mt-6 space-y-3">
        {points.map((p) => (
          <li key={p} className="flex items-start gap-3">
            <span className="mt-0.5 w-5 h-5 rounded-full bg-amber-500/15 flex items-center justify-center shrink-0">
              <Check className="w-3 h-3 text-amber-600" />
            </span>
            <span className="text-slate-700 text-[15px] leading-relaxed">{p}</span>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const FeaturedSolutions = () => {
  const { lang } = useLanguage();
  const t = translations[lang].featured;

  return (
    <section className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading tag={t.tag} title={t.title} center />
        <div className="mt-16 space-y-20">
          <Reveal>
            <FeatureCard
              tag={t.card1Tag}
              title={t.card1Title}
              desc={t.card1Desc}
              points={t.card1Points}
              image={IMAGES.cloud1}
              icon={Printer}
            />
          </Reveal>
          <Reveal>
            <FeatureCard
              tag={t.card2Tag}
              title={t.card2Title}
              desc={t.card2Desc}
              points={t.card2Points}
              image={IMAGES.bi1}
              icon={BarChart3}
              reverse
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSolutions;
